import React from "react";
import "./footer.scss";

interface FooterContainerProps {
  children?: React.ReactNode;
}

export const FooterContainer: React.FC<FooterContainerProps> = ({
  children,
}: FooterContainerProps) => {
  return (
    <div className="footer-container">
      <div className="footer">{children}</div>
    </div>
  );
};
